
class AnimatedLogo
{

    init(){
        const parentContainer = this.$el.closest('.Pegasus__Container');

        if(!parentContainer){
            return;
        }

        parentContainer.classList.add('additional-padding-mobile');
    }

}


document.addEventListener('alpine:init', () => {
    Alpine.data('animatedLogo', () => new AnimatedLogo());
});